import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from '@chakra-ui/react'
import React, { useRef } from 'react'
import { useLanguage } from '../../hooks/utility/useLanguage'

interface DeleteConversationDialogProps {
  isOpen: boolean
  conversationTitle: string
  onClose: () => void
  onConfirm: () => void
}

const DeleteConversationDialog: React.FC<DeleteConversationDialogProps> = ({
  isOpen,
  conversationTitle,
  onClose,
  onConfirm,
}) => {
  const { t } = useLanguage()
  // AlertDialog requires a focusable element to receive focus on open; the
  // Cancel button is the safe default so an accidental Enter does not delete.
  const cancelRef = useRef<HTMLButtonElement>(null)

  const handleConfirm = () => {
    onConfirm()
    onClose()
  }

  return (
    <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {t('sidebar.deleteConversation', { defaultValue: 'Delete conversation' })}
          </AlertDialogHeader>

          <AlertDialogBody>
            {t('sidebar.deleteConversationConfirm', {
              title: conversationTitle,
              defaultValue: 'Are you sure you want to delete the chat conversation: {{title}}?',
            })}
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} variant="outline" onClick={onClose}>
              {t('common.cancel', { defaultValue: 'Cancel' })}
            </Button>
            <Button onClick={handleConfirm} ml={3}>
              {t('sidebar.delete', { defaultValue: 'Delete' })}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}

export default DeleteConversationDialog
